import { Button, Drawer, Row, Col } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COLOR, FONT } from '../constants';
import { setDrawerVisible } from '../redux/actions/common';
import {
  CloseOutlined
} from '@ant-design/icons';

import styled from 'styled-components'

const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    height: auto !important;
  }
  .ant-drawer-content {
    border-radius: 0 0 8px 8px;
  }
`

const AppDrawer = () => {
  const drawerVisible = useSelector(state => state.app.drawerVisible)
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(setDrawerVisible(false))
  };



  return (
    <>
      <StyledDrawer
        destroyOnClose
        title={null}
        placement="top"
        closable={false}
        onClose={onClose}
        visible={drawerVisible}
        key="top"
        bodyStyle={{ padding: '10px 16px 40px 16px', background: COLOR.secondary }}
        contentWrapperStyle={{ borderRadius: 8 }}
      >
        <Row justify='space-between' align='middle' style={{
          minHeight: 60, marginBottom: 20
        }}>
          <Col span={9}>
            <img src="./company_logo.svg" alt="company logo" style={{ width: '100%', }} />
          </Col>
          <Col>
            <Button type='text' onClick={() => dispatch(setDrawerVisible(false))}>
              <CloseOutlined style={{ fontSize: 28 }} />
            </Button>
          </Col>
        </Row>
        <Row justify='center' style={{ textAlign: 'center' }} gutter={[0, 20]}>
          <Col span={24}>
            <a href="#collection-mint">
              <Button style={{ ...FONT.h5, color: COLOR.menuText }} onClick={() => dispatch(setDrawerVisible(false))} type='text'>COLLECTION</Button>
            </a>
          </Col>
          <Col span={24}>
            <a href="#collection-info">
              <Button style={{ ...FONT.h5, color: COLOR.menuText }} onClick={() => dispatch(setDrawerVisible(false))} type='text'>ABOUT</Button>
            </a>
          </Col>
          <Col span={24}>
            <a href="#blockchain-faq">
              <Button style={{ ...FONT.h5, color: COLOR.menuText }} onClick={() => dispatch(setDrawerVisible(false))} type='text'>FAQ</Button>
            </a>
          </Col>
          <Col span={24}>
            <a href="#team-member">
              <Button style={{ ...FONT.h5, color: COLOR.menuText }} onClick={() => dispatch(setDrawerVisible(false))} type='text'>TEAM</Button>
            </a>
          </Col>
          <Col span={24}>
            <a href="#contact-us">
              <Button style={{ ...FONT.h5, color: COLOR.menuText }} onClick={() => dispatch(setDrawerVisible(false))} type='text'>CONTACT US</Button>
            </a>
          </Col>
          <Col span={24}>
            <img src="./assets/slash.svg" alt="Slash" style={{ width: 24 }} />
          </Col>
          <Col span={12}>
            <Row justify='space-between'>
              <Col>
                <a href="https://www.facebook.com/t9technine/" target="_blank" rel="noreferrer"><img
                  src="./assets/facebook_color.svg" alt="Facebook" style={{ width: 20 }} /></a>
              </Col>
              <Col>
               <a href="https://www.linkedin.com/company/technine/" target="_blank" rel="noreferrer"> <img
                  src="./assets/linkedin_color.svg" alt="Linkedin" style={{ width: 20 }} /></a>
              </Col>
              <Col>
               <a href="https://www.visiongo.hsbc.com.hk/zh-HK/company/technine/" target="_blank" rel="noreferrer"> <img
                  src="./assets/hsbc_color.svg" alt="HSBC" style={{ width: 40 }} /></a>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledDrawer>
    </>
  );
};

export default AppDrawer;